/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */
import './email-chips.scss';

/* eslint-disable import/no-unresolved, import/default */

import emailChipsTemplate from './email-chips.tpl.html';

/* eslint-enable import/no-unresolved, import/default */

export default angular.module('tektelic.components.emailChips', [])
    .directive('tkEmailChips', EmailChips)
    .name;

const emailRegex = /^[_a-zA-Z0-9-]+(\.[_a-zA-Z0-9-]+)*@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*(\.[a-zA-Z]{2,4})$/

/*@ngInject*/
function EmailChips($compile, $mdConstant, $templateCache) {

    return {
        restrict: "E",
        require: "^ngModel",
        scope: {
            tkRequired: '=?',
            placeholder: '@?',
            secondaryPlaceholder: '@?'
        },
        link: linker
    };

    function linker( scope, element, attrs, ngModelCtrl ) {

        var template = $templateCache.get(emailChipsTemplate);

        element.html(template);

        scope.emails = [];

        var semicolon = 186;
        scope.emailSeparatorKeys = [$mdConstant.KEY_CODE.ENTER, $mdConstant.KEY_CODE.COMMA, semicolon];
        scope.emptySeparatorKeys = [null];

        scope.emailChipsKeyup = emailChipsKeyup;
        scope.emailChipsKeydown = emailChipsKeydown;

        scope.ngModelCtrl = ngModelCtrl;
        scope.showErrors = false;

        ngModelCtrl.$render = function () {
            if (ngModelCtrl.$viewValue) {
                var value = ngModelCtrl.$viewValue;
                value.forEach(function (email) {
                    scope.emails.push(email);
                });
            }
            scope.$watch('emails', function (newVal, prevVal) {
                if (!angular.equals(newVal, prevVal)) {
                    scope.showErrors = true;
                    updateValue();
                }
            }, true);

            scope.$watch('tkRequired', function (newVal, prevVal) {
                if (!angular.equals(newVal, prevVal)) {
                    validateEmails();
                }
            });
            validateEmails();
        }

        function updateValue() {
            var value = [];
            scope.emails.forEach(function (email) {
                value.push(email);
            });
            ngModelCtrl.$setViewValue(value);
            validateEmails();
        }

        function emailChipsKeyup() {
            var chipBuffer = scope.mdChipsCtrl.getChipBuffer();
            if (chipBuffer && chipBuffer.trim().length) {
                ngModelCtrl.$setValidity('buffer', false);
            } else {
                ngModelCtrl.$setValidity('buffer', true);
            }
        }

        function emailChipsKeydown($event) {
            var chipBuffer = scope.mdChipsCtrl.getChipBuffer();
            if (!chipBuffer) {
                return;
            }
            if (scope.emailSeparatorKeys.indexOf($event.keyCode) !== -1) {
                $event.preventDefault();
                if (validateEmailFormat(chipBuffer.trim())) {
                    if (scope.mdChipsCtrl.hasMaxChipsReached()) return;
                    scope.mdChipsCtrl.appendChip(chipBuffer.trim());
                    scope.mdChipsCtrl.resetChipBuffer();
                    return false;
                }
            } else {
                ngModelCtrl.$setValidity('emailFormat', true);
            }
        }

        function validateEmails() {
            if (scope.tkRequired) {
                ngModelCtrl.$setValidity('required', scope.emails.length > 0);
            } else {
                ngModelCtrl.$setValidity('required', true);
            }
        }

        function validateEmailFormat(chip) {
            if (!emailRegex.test(chip)) {
                scope.showErrors = true;
                ngModelCtrl.$setValidity('emailFormat', false);
                return false;
            } else {
                ngModelCtrl.$setValidity('emailFormat', true);
                return true;
            }
        }

        $compile(element.contents())(scope);

        scope.chipsElement = angular.element('.md-chips', element);
        scope.mdChipsCtrl = scope.chipsElement.scope().$mdChipsCtrl;
        scope.mdChipsCtrl.onInputBlur = function () {
            scope.showErrors = true;
        }

        var parentResetChipBuffer = scope.mdChipsCtrl.resetChipBuffer;
        scope.mdChipsCtrl.resetChipBuffer = function() {
            parentResetChipBuffer.apply(scope.mdChipsCtrl);
            ngModelCtrl.$setValidity('buffer', true);
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/components/email-chips.directive.js